import { useEffect } from "react";

const TreeNationWidget = () => {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://widgets.tree-nation.com/js/widgets/v3/widgets.min.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://widgets.tree-nation.com/js/widgets/v3/widgets.min.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="flex justify-center pt-2 pb-4 mb-16 lg:mb-0">
      <div
        data-widget-type="offset-website"
        data-tree-nation-code="7493d2ca40b83a04"
        data-lang="en"
        data-theme="dark-monochrome"
      />
    </div>
  );
};

export default TreeNationWidget;